import Task from "../../model2/task/task"
import {ACLRole} from "./user-roles"
import TaskWorkflow from "../../model2/status/task-workflow"
import Status from "../../model2/status/status"

export default class ACLTask {

    constructor(config?:any) {
    }

    private isARUser(task: Task): boolean {
        return task.actionRequiredUserId === gd.user.id
    }

    private isCreatorUser(task: Task): boolean {
        return task.createdByUserId === gd.user.id
    }

    private isProjectFullAccess(task: Task): boolean {
        return gd.ac.check.project.fullAccess(task.projectId)
    }

    private isProjectStandardAccess(task: Task): boolean {
        return gd.ac.check.project.standardAccess(task.projectId)
    }

    hasFullAccess(task: Task) : boolean {
        return this.isARUser(task) || this.isCreatorUser(task) || this.isProjectFullAccess(task)
    }

    hasAccess(task: Task) : boolean {
        return this.isARUser(task) || this.isCreatorUser(task) || this.isProjectStandardAccess(task)
    }

    isOpen(task: Task) : boolean {
        return !task.isClosed
    }

    editDescription(task:Task) {

        if (gd.companyId === 'kw82SH') {
            if (task.aclRole(ACLRole.TASK_CREATOR) || gd.ac.check.isOrganizationAdmin()) return true
            return false
        }

        return true
    }

    addDescription(task:Task) {
        return this.editDescription(task)
    }

    useStatus(task: Task, status:Status, workflow: TaskWorkflow) {

        // !!! tut blin ne vsegda task as model peredaetsya po hodu...

        if (gd.companyId === 'kw82SH') {

            if (gd.ac.check.isOrganizationAdmin()) return true

            const currentStatus = workflow.get(task.statusId)
            if (!currentStatus) {
                return status.key === 0
            }
            if (status.key===currentStatus?.key || status.key===currentStatus?.key+1 || status.key===currentStatus?.key-1) {
                return true
            }

            return false
        }

        return true
    }

    useStatusFullCheck(task: Task, statusId:ID) {

        const taskWorkflow = TaskWorkflow.initByTask(task)

        let status = taskWorkflow.get(statusId)

        if (!status) {
            console.log("no status in current workflow ... ok get from somewhere")
            status = Status.initById(statusId)
        }

        return this.useStatus(task, status, TaskWorkflow.initByTask(task))
    }

    editStoryPoints(task:Task):boolean {
        return this.isOpen(task) && this.hasFullAccess(task)
    }

    canRename(task:Task): boolean {
        return this.hasAccess(task)
    }

    canMove(task:Task): boolean {
        return this.hasAccess(task)
    }

    canChangeType(task:Task): boolean {
        return this.hasAccess(task)
    }

    canAddTimeTracking(task:Task): boolean {
        return this.hasAccess(task)
    }

    canChangeStatus(task:Task): boolean {
        return this.hasAccess(task)
    }

    canAddReminder(task:Task): boolean {
        return this.hasAccess(task)
    }

    canDuplicate(task:Task): boolean {
        return this.hasAccess(task)
    }

    canAddRecurrence(task:Task): boolean {
        return this.isProjectStandardAccess(task)
    }
}